const RootActionTypes = {
    LOGOUT: "LOGOUT"
}

export default RootActionTypes